import { render, staticRenderFns } from "./ComponentDocument.vue?vue&type=template&id=ff90fc56&scoped=true"
import script from "./ComponentDocument.vue?vue&type=script&lang=js"
export * from "./ComponentDocument.vue?vue&type=script&lang=js"
import style0 from "./ComponentDocument.vue?vue&type=style&index=0&id=ff90fc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff90fc56",
  null
  
)

export default component.exports